import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {
  1: { // Exercise num
    unit: 'Unit 12',
    id: 'SB3-U12-P84-E1',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    titleQuestion: [{ num: '1', title: 'Look at the pictures. What are the children wearing?', color: "#1F4199" }],
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page84/E1/1.jpg' }],],
  },
  2: { // Exercise num
    unit: 'Unit 12',
    id: 'SB3-U12-P84-E2',
    audio: 'img/FriendsPlus/Page84/Audio/audio-e2-p84.mp3',
    video: '',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page84/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page84/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page84/Audio/tieude-e2-p84.mp3' },
        { url: 'img/FriendsPlus/Page84/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page84/E2/4.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 12',
    id: 'SB3-U12-P84-E3',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page84/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Read again. Circle the false word and write the correct word.', color: "#1F4199" }],
    question: {
      Write: {
        checkUppercase: true,
        inputStyle: { width: 200, marginLeft: 20, color: '#00a8ec' },
        answers: ['afternoon', 'classroom', 'red', 'English'],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {},
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', borderRadius: '50%', padding: 3 },
        limitSelect: 1,
        listWords: [
          'The play was in the morning.', //0
          'The play was in the school_yard.', //1
          'Xuan’s costume was blue.', //2
          'Mrs. Chi is the art teacher.', //3
        ],
        answers: ['0-10', '1-10', '2-6', '3-8'],
        initialValue: [],
      },
      Layout: `
        <img src="img/FriendsPlus/Page84/E3/1.jpg" style="width: 100%">
        <div style='display: flex; flex-direction: row;position: relative;'>
          <div style='flex: 3'>
            <div><b>1</b>&nbsp;The play was on <span style="border: 2px solid rgb(0, 168, 236);padding: 3px;border-radius: 50%;">Tuesday.</span></div>
            <div><b>2</b> <input id='0' type='Circle' /></div>
            <div><b>3</b> <input id='1' type='Circle' /></div>
            <div><b>4</b> <input id='2' type='Circle' /></div>
            <div><b>5</b> <input id='3' type='Circle' /></div>
          </div>
          <div style='flex: 1'>
            <div><u style='color: #00a8ec'>&emsp;Thursday&emsp;</u></div>
            <div><input id='0' /></div>
            <div><input id='1' /></div>
            <div><input id='2' /></div>
            <div><input id='3' /></div>
          </div>
        </div>
      `,
    },
  },
}

export default json;